/* eslint-disable */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-one-expression-per-line */
import { Suspense, useCallback, useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import ImagesFinder from '@/Components/ImagesFinder/ImagesFinder';
import { newTabs } from './TabsData';
import styles from './AiPacakging.module.scss';
import { notificationServices } from '@/Services';
import aiPackaging from '@/Services/aiPackaging.services';
import { useAuth } from '@/Components/Auth/Login/auth';
import {
	filtersInfoChip,
	formatDate,
	handleResponseStreamDownload,
	serializeVisibilityForAmountCaption,
} from '@/Helpers';
import { BackdropLoader } from '@/Components/Loaders';
import drawerActions from '@/Actions/drawer.actions';
import ExportDrawer from './ExportDrawer';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import AmountContainer from '@/Components/Forms/Payment Settlements/Amount Container/AmountContainer';
import { Download, Filter } from 'lucide-react';
import { Button, Chip } from '@mui/material';
import { modalActions } from '@/Actions';
import excel from '../../Images/excel.svg';
import CalculationInfoModal from './calculationInfoModal';
import cogsAnalyticsServices from '@/Services/Analytics Services/cogsAnalytics.services';
import AmountContainerDiv from '@/Components/Forms/Payment Settlements/AmountContainerDiv';
import moment from 'moment';

const parentTabs = [
	{
		id: 1,
		value: 'ISSUED',
		header: 'Issued Summary',
	},
	{
		id: 2,
		value: 'PRODUCED',
		header: 'Produced Summary',
	},
	{
		id: 3,
		value: 'DISPATCHED',
		header: 'Dispatch Summary',
	},
	{
		id: 4,
		value: 'INDENT',
		header: 'Restaurant Indent',
	},
];

const meals = [
	{
		id: 55,
		value: 'breakfast',
		header: 'BreakFast',
	},
	{
		id: 56,
		value: 'lunch',
		header: 'Lunch',
	},
	{
		id: 57,
		value: 'snacks',
		header: 'Snacks',
	},
	{
		id: 54,
		value: 'dinner',
		header: 'Dinner',
	},
	{
		id: -999,
		value: 'allDay',
		header: 'All Day',
	},
];

const filtersInfo = {
	header: {
		store: false,
		date: false,
	},
	kitchenBaseStore: {
		text: 'Kitchen ',
		show: true,
	},
	pods: {
		text: 'Pods',
		show: false,
	},
	dateRange: {
		text: 'Date Range',
		show: true,
	},
	orderType: {
		text: 'Tab Type',
	},
};
function AiPackagingNew(props) {
	const {
		toggleExportDrawer,
		toggleFiltersDrawer,
		toggleAifmsSummaryInfoModal,
	} = props;
	const { appConfig = {} } = useAuth();
	const useQueryParams = () => {
		const { search } = useLocation();
		return new URLSearchParams(search);
	};
	const params = useQueryParams();
	// http://localhost:3000/console2/ai-packaging-new?parentValue=SOURCING&mealType=lunch&dateOnly=%7B%22active%22%3Atrue%2C%22date%22%3A%222025-08-05T19%3A31%3A00.000Z%22%7D
	const queryParentValue = params
		.get('parentValue')
		?.replace(/^['"]|['"]$/g, '');
	const dateRangeOnly = params.get('dateRangeOnly');
	const hasSetInitialParamMealType = useRef(false);
	const queryMealType = params.get('mealType')?.replace(/^['"]|['"]$/g, '');
	const queryMealTypeId = params
		.get('mealTypeId')
		?.replace(/^['"]|['"]$/g, '');
	const formStore = params.get('fromPod');
	const toPodFilter = params.get('toPod');
	const { combineCMSBatches } = appConfig?.configs ?? {};
	const [tabsData, setTabsData] = useState([]);
	const [active, setActive] = useState(null);
	const [data, setData] = useState([]);
	const [filterData, setFilterData] = useState({});
	const [loading, setIsLoading] = useState(false);
	const [headerData, setHeaderData] = useState({});
	const [dataBox, setDataBox] = useState([]);
	const [statsSummary, setStatsSummary] = useState([]);
	const initialParentTab = parentTabs?.find?.((ele) => {
		if (queryParentValue === 'DISPATCHED') {
			return ele?.value === 'DISPATCHED';
		} else if (queryParentValue === 'PRODUCED') {
			return ele?.value === 'PRODUCED';
		} else if (queryParentValue === 'INDENT') {
			return ele?.value === 'INDENT';
		} else {
			return ele?.value === 'ISSUED';
		}
	});
	const [parentTab, setParentTab] = useState(
		initialParentTab ?? parentTabs[0]
	);
	const [sortColumn, setSortColumn] = useState();
	const [sortType, setSortType] = useState();
	const handleSortColumn = useCallback((column, type) => {
		setSortColumn(column);
		setSortType(type);
	}, []);

	const handleParentTab = (tab) => {
		setParentTab(tab);
		fetchData(filterData, tab);
		handleSortColumn(null, null);
	};

	const handleTabs = (tab) => {
		setActive(tab);
	};

	const fetchCogsAnalysisGraph = async (dateRange, shiftId) => {
		try {
			const apiCalls = [];
			const basePayload = {
				avoidGraph: true,
				grouping: {
					active: true,
					type: 'geographyWise',
					currentSelection: 'brand',
					selection: {},
				},
				shiftId: shiftId == -999 ? null : shiftId,
				analysisType: 'BOM',
			};

			const today = moment().startOf('day');
			apiCalls.push(
				cogsAnalyticsServices?.fetchCogsAnalysisGraph({
					req: {
						data: {
							...basePayload,
							dateRangeFilter: {
								from: moment(dateRange?.from).format(
									'YYYY-MM-DD'
								),
								to: moment(dateRange?.to).format('YYYY-MM-DD'),
							},
						},
					},
				})
			);

			if (
				today.isBetween(
					moment(dateRange?.from).startOf('day'),
					moment(dateRange?.to).startOf('day'),
					null,
					'[]'
				)
			) {
				apiCalls.push(
					cogsAnalyticsServices?.fetchCogsAnalysisGraphToday({
						req: {
							data: {
								...basePayload,
								dateRangeFilter: {
									from: today.format('YYYY-MM-DD'),
									to: today.format('YYYY-MM-DD'),
								},
							},
						},
					})
				);
			}

			const [response, responseToday] = await Promise.all(apiCalls);

			if (response?.statusCode === 200) {
				const mergedStatsData = mergeStatsData(
					response?.data?.statsData,
					responseToday?.data?.statsData
				);
				const processedStats = processStatsData(mergedStatsData);
				const statsSummary = Object?.keys(processedStats)?.map(
					(ele) => {
						return serializeVisibilityForAmountCaption(
							processedStats,
							ele
						);
					}
				);
				setStatsSummary(statsSummary);
			} else {
				notificationServices?.generateNotification({
					type: 'error',
					message: response?.message,
				});
			}
		} catch (error) {
			notificationServices?.generateNotification({
				type: 'error',
				message: 'Failed to fetch analytics data',
			});
		}
	};

	const mergeStatsData = (historicalData, todayData) => {
		if (!historicalData) return {};
		if (!todayData) return historicalData;

		let mergedData = { ...historicalData };

		// Handle array format for today's data
		if (Array.isArray(todayData)) {
			todayData.forEach((todayItem) => {
				// Find matching item in historical data by label
				const historicalKey = Object.keys(historicalData).find(
					(key) => historicalData[key].label === todayItem.label
				);

				if (
					historicalKey &&
					typeof historicalData[historicalKey].value === 'number' &&
					typeof todayItem.value === 'number'
				) {
					mergedData[historicalKey] = {
						...historicalData[historicalKey],
						value:
							historicalData[historicalKey].value +
							todayItem.value,
					};
				}
			});
		} else {
			// Handle object format for today's data
			Object.keys(historicalData).forEach((key) => {
				if (
					todayData[key] &&
					typeof historicalData[key].value === 'number' &&
					typeof todayData[key].value === 'number'
				) {
					mergedData[key] = {
						...historicalData[key],
						value: historicalData[key].value + todayData[key].value,
					};
				}
			});
		}

		return mergedData;
	};

	const processStatsData = (statsData) => {
		if (!statsData) return statsData;

		const processedData = { ...statsData };

		// Find Kitchen Ideal Cost for percentage calculation
		const idealCostKey = 3;

		if (!idealCostKey || !processedData[idealCostKey]?.value) {
			return processedData;
		}

		const idealCost = processedData[idealCostKey].value;

		// Recalculate percentages based on ideal cost
		Object.keys(processedData).forEach((key) => {
			if (
				key !== idealCostKey &&
				processedData[key].value &&
				idealCost > 0
			) {
				const percentage = Math.round(
					(processedData[key].value / idealCost) * 100
				);
				processedData[key] = {
					...processedData[key],
					percentageValue: percentage,
				};
			}
			if (
				['1', '2', '3', 1, 2, 3].includes(key) &&
				processedData[key]['percentageValue'] !== undefined
			) {
				processedData[key]['percentageValue'] = undefined;
			}
		});

		return processedData;
	};

	// useEffect(() => {
	// 	fetchCogsAnalysisGraph();
	// }, []);

	// useEffect(() => {
	// 	if (formStore || toPodFilter) {
	// 		// console.log(dateRangeOnly, 'dateRangeOnly');
	// 		const parsedDate = dateRangeOnly ? JSON.parse(dateRangeOnly) : null;
	// 		// console.log(parsedDate, 'parsedDate');
	// 		const fromDate = parsedDate?.from ? moment(parsedDate.from).toDate() : null;
	// 		const toDate = parsedDate?.to ? moment(parsedDate.to).toDate() : null;

	// 		setFilterData({
	// 			...filterData,
	// 			// dateOnly: parsedDate
	// 			// 	? {
	// 			// 			active: parsedDate.active,
	// 			// 			date: dateObj,
	// 			// 	  }
	// 			// 	: null,
	// 			fromPodFilter: formStore,
	// 			toPodFilter: toPodFilter,
	// 		});
	// 	}
	// }, []);

	const checkNull = (value) => {
		if ([-999, '-999', undefined, null, ''].includes(value)) {
			return null;
		}
		if (Number(value) === 0) {
			return null;
		}
		return Number(value);
	};

	const fetchData = async (filter, tab = parentTab) => {
		setFilterData(filter);
		const date = filter?.dateOnly?.date;
		const dateRange = filter?.dateRange;
		// const formattedDate = date.toISOString().split('T')[0];
		const req = {
			data: {
				filters: {
					// dateRangeFilter: {
					// 	from: formattedDate,
					// 	to: formattedDate,
					// },
					dateRangeFilter: {
						from: moment(dateRange?.from).format('YYYY-MM-DD'),
						to: moment(dateRange?.to).format('YYYY-MM-DD'),
					},
					fromStore: filter?.fromPodFilter?.id
						? checkNull(filter?.fromPodFilter?.id)
						: checkNull(formStore),
					storeId: filter?.toPodFilter?.id
						? checkNull(filter?.toPodFilter?.id)
						: checkNull(toPodFilter),
					analysisType: tab?.value,
				},
			},
		};
		try {
			if (
				filter?.fromPodFilter === '' ||
				filter?.fromPodFilter === null
			) {
				notificationServices?.generateNotification({
					type: 'error',
					message: 'Kitchen is Manadatory',
				});
				return;
			}
			// fetchCogsAnalysisGraph(filter?.dateRange, active?.id);
			// if (onlyStats) {
			// return;
			// }
			setIsLoading(true);
			const response = await aiPackaging?.aiPackagingGetDataWithHeaders(
				req
			);
			if (response?.statusCode === 200) {
				const { data } = response;
				const { headers, mealWiseScanData } = data;
				setHeaderData(headers);
				setData(mealWiseScanData);
			} else {
				notificationServices?.generateNotification({
					type: 'error',
					message: response?.message,
				});
			}
		} catch (error) {
			notificationServices?.generateNotification({
				type: 'error',
				message: error,
			});
		} finally {
			setIsLoading(false);
		}
	};

	const handleExportClick = async () => {
		const fromDate = filterData?.dateRange?.from;
		const toDate = filterData?.dateRange?.to;
		const formattedFromDate = formatDate(fromDate);
		const formattedToDate = formatDate(toDate);
		if (formattedFromDate === '' || formattedToDate === '' || formattedFromDate === null || formattedToDate === null) {
			notificationServices?.generateNotification({
				type: 'error',
				message: 'Date is Manadatory',
			});
			return;
		}
		const req = {
			data: {
				filters: {
					dateRangeFilter: {
						from: formattedFromDate,
						to: formattedToDate,
					},
					fromStore: filterData?.fromPodFilter?.id
						? checkNull(filterData?.fromPodFilter?.id)
						: checkNull(formStore),
					storeId: filterData?.toPodFilter?.id
						? checkNull(filterData?.toPodFilter?.id)
						: checkNull(toPodFilter),
					analysisType: parentTab?.value,
					
				},
			},
		};
		try {
			setIsLoading(true);
			const response = await aiPackaging?.aiPacakgingExport(req);
			handleResponseStreamDownload(response, `${parentTab?.value} ${formattedFromDate} to ${formattedToDate}.csv`);
		} catch (error) {
			notificationServices.generateNotification({
				type: 'error',
				message: error,
			});
		} finally {
			setIsLoading(false);
		}
	};

	useEffect(() => {
		if (tabsData.length > 0) {
			const tabsArray = newTabs(tabsData);
			let mealType = tabsArray[0];
			if (
				queryMealType &&
				queryMealType?.length > 0 &&
				!hasSetInitialParamMealType.current
			) {
				hasSetInitialParamMealType.current = true;
				mealType =
					queryMealType &&
					queryMealType?.length > 0 &&
					tabsArray?.find(
						(ele) =>
							ele?.value?.toLowerCase() ===
							queryMealType?.toLowerCase()
					)
						? tabsArray?.find(
								(ele) =>
									ele?.value?.toLowerCase() ===
									queryMealType?.toLowerCase()
						  )
						: tabsArray[0];
			} else if (
				queryMealTypeId &&
				queryMealTypeId?.length > 0 &&
				!hasSetInitialParamMealType.current
			) {
				hasSetInitialParamMealType.current = true;
				mealType =
					queryMealTypeId &&
					queryMealTypeId?.length > 0 &&
					tabsArray?.find(
						(ele) => ele?.id === Number(queryMealTypeId)
					)
						? tabsArray?.find(
								(ele) => ele?.id === Number(queryMealTypeId)
						  )
						: tabsArray[0];
			}
			setActive(mealType);
			// fetchCogsAnalysisGraph(filterData?.dateRange, active?.id);
		}
	}, [tabsData]);
	useEffect(() => {
		fetchCogsAnalysisGraph(filterData?.dateRange, active?.id);
	}, [filterData, active?.id]);

	useEffect(() => {
		if (!data) return;
		const mealType = data?.map((ele, index) => {
			return ele?.mealType;
		});
		const tabData = meals.filter((ele) => mealType.includes(ele?.value));
		setTabsData(tabData);
	}, [data]);

	useEffect(() => {
		const boxvalues = [];
		if (headerData.orderedWeight !== undefined) {
			boxvalues.push({
				caption: 'Ordered',
				amount: `${headerData.orderedWeight} kg`,
				color: '#f8DE7E',
			});
		}
		if (headerData.fulfilledWeight !== undefined) {
			const percentage =
				(headerData.fulfilledWeight / headerData.orderedWeight) * 100;
			boxvalues.push({
				caption: 'Fulfilled',
				amount: `${headerData.fulfilledWeight} kg`,
				percentageValue: isNaN(percentage)
					? '0%'
					: `${Number(percentage).toFixed(2)}%`,
				color: '#f8ed62',
			});
		}

		if (
			headerData.fulfilledCountOnlyItems !== undefined &&
			headerData.orderedCountOnlyItems !== undefined
		) {
			const percentage =
				(headerData.fulfilledCountOnlyItems /
					headerData.orderedCountOnlyItems) *
				100;
			boxvalues.push({
				caption: 'Item By Count',
				amount: `${headerData.fulfilledCountOnlyItems} / ${headerData.orderedCountOnlyItems} pcs`,
				percentageValue: isNaN(percentage)
					? '0%'
					: `${Number(percentage).toFixed(2)}%`,
				color: '#928664',
			});
		}

		if (
			headerData.fulfilledWeightOnlyItems !== undefined &&
			headerData.orderedWeightOnlyItems !== undefined
		) {
			const percentage =
				(headerData.fulfilledWeightOnlyItems /
					headerData.orderedWeightOnlyItems) *
				100;
			boxvalues.push({
				caption: 'Item By Weight',
				amount: `${headerData.fulfilledWeightOnlyItems} / ${headerData.orderedWeightOnlyItems} kg`,
				percentageValue: isNaN(percentage)
					? '0%'
					: `${Number(percentage).toFixed(2)}%`,
				color: '#dab600',
			});
		}

		if (headerData.machineUtilizationPercent !== undefined) {
			boxvalues.push({
				caption: 'Machine Utilization',
				amount: `${headerData.machineUtilizationPercent}%`,
				color: '#f4dfa7',
			});
		}

		if (headerData.containerUtilizationPercent !== undefined) {
			boxvalues.push({
				caption: 'Cambro Utilization',
				amount: `${headerData.containerUtilizationPercent}%`,
				color: '#f9A602',
			});
		}

		setDataBox(boxvalues);
	}, [headerData]);

	const exportInfo = {
		hideExportAccordian: true,
	};
	return (
		<div className='w-full overflow-hidden'>
			<BackdropLoader showProgress isLoading={loading} />
			<ExportDrawer />
			<CalculationInfoModal />
			<ImagesFinder
				onSubmit={fetchData}
				disableFutureDate
				initialState={{ orderType: parentTab?.value }}
				filtersInfo={filtersInfo}
				hideDateRangeTimeType={true}
				exportInfo={exportInfo}
				tabType={parentTab?.value}
			/>
			<div className='flex justify-between mx-4 my-2 w-full items-center pr-4'>
				<div className='font-bold text-[16px] pr-2 whitespace-nowrap'>
					Operation Summary{' '}
				</div>
				{filtersInfoChip(filtersInfo, filterData)}
				<Button
					onClick={() => {
						toggleFiltersDrawer(true);
					}}
					className='flex justify-center gap-2 px-4 py-2 text-white bg-teal-600 border border-gray-300 rounded-md hover:bg-teal-700'
				>
					<span>Filter</span>
					<Filter className='size-4' />
				</Button>
			</div>
			<div className='flex justify-between mx-4 w-full items-center pr-4'>
				<div className='flex flex-1  items-start'>
					<div className='flex justify-center gap-2 rounded-md bg-[#FDE6AD] border border-[#00000033]'>
						{parentTabs?.map((ele) => {
							const isActive = parentTab?.id == ele?.id;
							return (
								<div
									className={`text-center px-4 py-2 text-base font-medium cursor-pointer min-w-max
										${isActive ? 'bg-[#ffb703]' : ''}`}
									onClick={() => handleParentTab(ele)}
								>
									{ele?.header}
								</div>
							);
						})}
					</div>
				</div>
				<div className='inline-flex flex-wrap justify-center gap-2 m-[12px] rounded-md bg-[#FDE6AD] border border-[#00000033]'>
					{newTabs(tabsData)?.map((ele) => {
						const isActive = active?.id === ele?.id;
						return (
							<div
								className={`text-center px-4 py-2 text-base font-medium cursor-pointer min-w-max
										${isActive ? 'bg-[#ffb703]' : ''}`}
								onClick={() => handleTabs(ele)}
							>
								{ele?.header}
							</div>
						);
					})}
				</div>
			</div>
			<div className='w-[98%] flex flex-col  mx-auto relative'>
				{/* {dataBox?.map((ele, index) => {
							return (
								<AmountContainer
									color={ele?.color}
									amountCaption={{
										caption: ele?.caption,
										amount: ele?.amount,
										percentageValue: ele?.percentageValue,
									}}
									customStyle={true}
								/>
							);
						})} */}
				<AmountContainerDiv amountCaption={statsSummary} />
				{
					data?.length > 0 && (		
						<div
							onClick={() => {
								handleExportClick();
								// toggleExportDrawer(true);
							}}
							className={
								'absolute -bottom-2 right-0 w-[125px] text-center cursor-pointer flex items-center gap-1 z-[7] bg-[#1d6f42] text-white rounded-2xl px-2 py-1'
							}
						>
							<img src={excel} className='w-[25px]' alt='excel' />
							EXPORT
							<Download size={20} className='w-[20px] h-[20px]' />
						</div>
					)
				}
			</div>
			{data?.length > 0 ? (
				<>
					<Suspense fallback={<div>Loading ...</div>}>
						{active?.comp?.({
							parentValue: parentTab?.value,
							value: active?.value,
							handleExport:handleExportClick,
							handleSortColumn,
							sortColumn,
							sortType,
							data,
							filters: filterData,
							openModal: toggleAifmsSummaryInfoModal,
						})}
					</Suspense>
				</>
			) : (
				<div className='w-full text-center p-1  m-2 font-bold'>
					No Recipe Data Found
				</div>
			)}
		</div>
	);
}
const mapStateToProps = (state) => {
	return {};
};
const mapDispatchToProps = {
	toggleExportDrawer: drawerActions?.toggleExportDrawer,
	toggleFiltersDrawer: drawerActions?.toggleFiltersDrawer,
	toggleAifmsSummaryInfoModal: modalActions?.toggleAifmsSummaryInfoModal,
};
export default connect(mapStateToProps, mapDispatchToProps)(AiPackagingNew);
